import React from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';
import './index.less';

export declare type switchSize = 'm' | 'l';

export interface IABSSwitchProps {
  size?: switchSize;
  disabled?: boolean;
  onChange?: (checked: boolean) => any;
  className?: string;
  defaultChecked?: boolean;
}
export class ABSSwitch extends React.Component<IABSSwitchProps> {
  static defaultProps = {
    size: 'm'
  };

  render() { 
    const { size, disabled, onChange, className, defaultChecked } = this.props;
    const classes = classNames('', className, {
      [`abs-switch-${size}`]: true,
    });
    return(
      <div className="abs-switch">
        <Switch 
          className={classes}          
          disabled={disabled} 
          onChange={onChange} 
          defaultChecked={defaultChecked}
        />        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSwitch/index.tsx